// Less variables for color tokens
export const lessVariables = `
@colors-white: #FFFFFF;
@colors-black: #000000;

@colors-primary25: #FCFAFF;
@colors-primary37: #F4F2FF;
@colors-primary50: #EDEAFF;
@colors-primary100: #DCD6FF;
@colors-primary200: #B9ADFF;
@colors-primary300: #9583FF;
@colors-primary400: #725AFF;
@colors-primary500: #4F31FF;
@colors-primary600: #3F27CC;
@colors-primary700: #0E1680;
@colors-primary800: #201466;
@colors-primary900: #100A33;

@colors-error25: #FFF8F8;
@colors-error50: #FFEDEB;
@colors-error100: #FEDCD7;
@colors-error200: #FEB5B5;
@colors-error300: #FC9588;
@colors-error400: #FB7260;
@colors-error500: #EF4444;
@colors-error600: #C83F2D;
@colors-error700: #962F22;
@colors-error800: #642016;
@colors-error900: #32100B;

@colors-neutral25: #F9F9F9;
@colors-neutral50: #F2F2F2;
@colors-neutral100: #E6E6E6;
@colors-neutral200: #C4C4C4;
@colors-neutral300: #B3B3B3;
@colors-neutral400: #999999;
@colors-neutral500: #808080;
@colors-neutral600: #666666;
@colors-neutral700: #4D4D4D;
@colors-neutral800: #333333;
@colors-neutral900: #1A1A1A;

@colors-success25: #F5FFFA;
@colors-success50: #E7F8F2;
@colors-success100: #D1FAE5;
@colors-success200: #9FE3CD;
@colors-success300: #70D5B3;
@colors-success400: #40C79A;
@colors-success500: #10B981;
@colors-success600: #0D9467;
@colors-success700: #0A6F4D;
@colors-success800: #064A34;
@colors-success900: #03251A;

@colors-warning25: #FFFDF5;
@colors-warning50: #FFFBEB;
@colors-warning100: #FEF3C7;
@colors-warning200: #FDE68A;
@colors-warning300: #FCD34D;
@colors-warning400: #FBBF24;
@colors-warning500: #F59E0B;
@colors-warning600: #D97706;
@colors-warning700: #B45309;
@colors-warning800: #92400E;
@colors-warning900: #78350F;

// Design system naming aliases (keep legacy primary/error/success/warning for compatibility)
@colors-blue25: @colors-primary25;
@colors-blue37: @colors-primary37;
@colors-blue50: @colors-primary50;
@colors-blue100: @colors-primary100;
@colors-blue200: @colors-primary200;
@colors-blue300: @colors-primary300;
@colors-blue400: @colors-primary400;
@colors-blue500: @colors-primary500;
@colors-blue600: @colors-primary600;
@colors-blue700: @colors-primary700;
@colors-blue800: @colors-primary800;
@colors-blue900: @colors-primary900;

@colors-red25: @colors-error25;
@colors-red50: @colors-error50;
@colors-red100: @colors-error100;
@colors-red200: @colors-error200;
@colors-red300: @colors-error300;
@colors-red400: @colors-error400;
@colors-red500: @colors-error500;
@colors-red600: @colors-error600;
@colors-red700: @colors-error700;
@colors-red800: @colors-error800;
@colors-red900: @colors-error900;

@colors-green25: @colors-success25;
@colors-green50: @colors-success50;
@colors-green100: @colors-success100;
@colors-green200: @colors-success200;
@colors-green300: @colors-success300;
@colors-green400: @colors-success400;
@colors-green500: @colors-success500;
@colors-green600: @colors-success600;
@colors-green700: @colors-success700;
@colors-green800: @colors-success800;
@colors-green900: @colors-success900;

@colors-yellow25: @colors-warning25;
@colors-yellow50: @colors-warning50;
@colors-yellow100: @colors-warning100;
@colors-yellow200: @colors-warning200;
@colors-yellow300: @colors-warning300;
@colors-yellow400: @colors-warning400;
@colors-yellow500: @colors-warning500;
@colors-yellow600: @colors-warning600;
@colors-yellow700: @colors-warning700;
@colors-yellow800: @colors-warning800;
@colors-yellow900: @colors-warning900;

@colors-blurple: #4F31FF;
@colors-grape: #642A73;
@colors-cosmo: #ED207C;
@colors-spice: #FF852C;
@colors-lime: #D5F870;

@colors-miami600: #B84FAD;
@colors-miami400: #EF72E2;
@colors-miami200: #FFC8F9;

@colors-spice700: #AC581B;
@colors-spice500: #FF852C;
@colors-spice50: #FFF4EC;
@colors-spice200: #FDC399;

@colors-lime700: #586C1F;
@colors-lime500: #D5F870;
@colors-lime200: #F1F8DA;

// Sidebar Menu Colors (Figma redesign)
@colors-sidebar-bg: #f2f1f9;
@colors-background-grey: #F4F4F6;
@colors-nav-text-inactive: #676571;
@colors-nav-text-active: #1a1823;
@colors-nav-hover-bg: #f5f4fa;
@colors-section-header-text: #9ca3af;

// Semantic Colors
@semantic-text-primary: @colors-neutral800;
@semantic-text-secondary: @colors-neutral600;
@semantic-text-disabled-dropdown: @colors-neutral500;
@semantic-text-brand1: @colors-blue500;
@semantic-text-brand2: @colors-blue700;

@semantic-background-grey: @colors-background-grey;
@semantic-background-subtle-purple: @colors-primary25;

@semantic-border-card: @colors-neutral100;
@semantic-border-modal: @colors-neutral100;
@semantic-border-focus: @colors-blue500;
`;
export const colors = {
    // Shades
    white: "#FFFFFF",
    black: "#000000",
    // Blue (legacy primary* aliases kept for compatibility)
    primary25: "#FCFAFF",
    primary37: "#F4F2FF", // Used for sidebar background
    primary50: "#EDEAFF",
    primary100: "#DCD6FF",
    primary200: "#B9ADFF",
    primary300: "#9583FF",
    primary400: "#725AFF",
    primary500: "#4F31FF",
    primary600: "#3F27CC",
    primary700: "#0E1680",
    primary800: "#201466",
    primary900: "#100A33",
    blue25: "#FCFAFF",
    blue37: "#F4F2FF",
    blue50: "#EDEAFF",
    blue100: "#DCD6FF",
    blue200: "#B9ADFF",
    blue300: "#9583FF",
    blue400: "#725AFF",
    blue500: "#4F31FF",
    blue600: "#3F27CC",
    blue700: "#0E1680",
    blue800: "#201466",
    blue900: "#100A33",
    // Red (legacy error* aliases kept for compatibility)
    error25: "#FFF8F8",
    error50: "#FFEDEB",
    error100: "#FEDCD7",
    error200: "#FEB5B5",
    error300: "#FC9588",
    error400: "#FB7260",
    error500: "#EF4444",
    error600: "#C83F2D",
    error700: "#962F22",
    error800: "#642016",
    error900: "#32100B",
    red25: "#FFF8F8",
    red50: "#FFEDEB",
    red100: "#FEDCD7",
    red200: "#FEB5B5",
    red300: "#FC9588",
    red400: "#FB7260",
    red500: "#EF4444",
    red600: "#C83F2D",
    red700: "#962F22",
    red800: "#642016",
    red900: "#32100B",
    // Neutral (Obsidian)
    neutral25: "#F9F9F9",
    neutral50: "#F2F2F2",
    neutral100: "#E6E6E6",
    neutral200: "#C4C4C4",
    neutral300: "#B3B3B3",
    neutral400: "#999999",
    neutral500: "#808080",
    neutral600: "#666666",
    neutral700: "#4D4D4D",
    neutral800: "#333333",
    neutral900: "#1A1A1A",
    // Green (legacy success* aliases kept for compatibility)
    success25: "#F5FFFA",
    success50: "#E7F8F2",
    success100: "#D1FAE5",
    success200: "#9FE3CD",
    success300: "#70D5B3",
    success400: "#40C79A",
    success500: "#10B981",
    success600: "#0D9467",
    success700: "#0A6F4D",
    success800: "#064A34",
    success900: "#03251A",
    green25: "#F5FFFA",
    green50: "#E7F8F2",
    green100: "#D1FAE5",
    green200: "#9FE3CD",
    green300: "#70D5B3",
    green400: "#40C79A",
    green500: "#10B981",
    green600: "#0D9467",
    green700: "#0A6F4D",
    green800: "#064A34",
    green900: "#03251A",
    // Yellow (legacy warning* aliases kept for compatibility)
    warning25: "#FFFDF5",
    warning50: "#FFFBEB",
    warning100: "#FEF3C7",
    warning200: "#FDE68A",
    warning300: "#FCD34D",
    warning400: "#FBBF24",
    warning500: "#F59E0B",
    warning600: "#D97706",
    warning700: "#B45309",
    warning800: "#92400E",
    warning900: "#78350F",
    yellow25: "#FFFDF5",
    yellow50: "#FFFBEB",
    yellow100: "#FEF3C7",
    yellow200: "#FDE68A",
    yellow300: "#FCD34D",
    yellow400: "#FBBF24",
    yellow500: "#F59E0B",
    yellow600: "#D97706",
    yellow700: "#B45309",
    yellow800: "#92400E",
    yellow900: "#78350F",
    // Brand Colors
    blurple: "#4F31FF",
    grape: "#642A73",
    cosmo: "#ED207C",
    spice: "#FF852C",
    lime: "#D5F870",
    // Sidebar Menu Colors (Figma redesign)
    sidebarBg: "#f2f1f9",
    backgroundGrey: "#F4F4F6",
    navTextInactive: "#676571",
    navTextActive: "#1a1823",
    navHoverBg: "#f5f4fa",
    sectionHeaderText: "#9ca3af",
    // Extended Spectrum - Miami
    miami600: "#B84FAD",
    miami400: "#EF72E2",
    miami200: "#FFC8F9",
    // Extended Spectrum - Spice
    spice700: "#AC581B",
    spice50: "#FFF4EC",
    spice500: "#FF852C",
    spice200: "#FDC399",
    // Extended Spectrum - Lime
    lime700: "#586C1F",
    lime500: "#D5F870",
    lime200: "#F1F8DA",
};
export const semanticColors = {
    // Text Colors
    textPrimary: colors.neutral800,
    textSecondary: colors.neutral600,
    textDisabledDropdown: colors.neutral500,
    textBrand1: colors.blue500,
    textBrand2: colors.blue700,
    // Background Colors
    backgroundGrey: colors.backgroundGrey,
    backgroundSubtlePurple: colors.primary25,
    // Border Colors
    borderCard: colors.neutral100,
    borderModal: colors.neutral100,
    borderFocus: colors.blue500,
};
